module.exports = __webpack_public_path__ + "static/media/172.ae08da6e.jpg";